import React from 'react';
import { useRedContext } from '../context/RedContext';
import { useEstadoApp } from '../context/EstadoAppContext';

const ResumenEntidad = () => {
    const { formData } = useRedContext();
    const { cambiarEstadoApp } = useEstadoApp();

    return (
        <div className="flex flex-col mb-6 p-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-800 dark:text-white">
                    Resumen de Entidad - {formData?.identidad?.nombre_completo || formData?.identidad?.nombre_entidad || 'Sin nombre'}
                </h2>
                <span className="text-sm text-gray-500">
                    ID RED: {formData?.identidad?.id_red || 'N/A'}
                </span>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded">
                    <p className="text-sm text-gray-600">Partido</p>
                    <p className="font-medium">{formData?.identidad?.partido_nombre || formData?.identidad?.municipio || 'No especificado'}</p>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded">
                    <p className="text-sm text-gray-600">Domicilio</p>
                    <p className="font-medium">{formData?.identidad?.domicilio || formData?.identidad?.domicilio_legal || 'No especificado'}</p>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded">
                    <p className="text-sm text-gray-600">Correo Electrónico</p>
                    <p className="font-medium">{formData?.identidad?.correo_electronico || formData?.identidad?.email || 'No especificado'}</p>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded">
                    <p className="text-sm text-gray-600">Teléfono</p>
                    <p className="font-medium">{formData?.identidad?.telefono || 'No especificado'}</p>
                </div>
            </div>
            
            <div className="flex gap-4">
                <button
                    onClick={() => cambiarEstadoApp('ediT')}
                    className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md"
                >
                    ← Volver a Editar
                </button>
                <button
                    onClick={() => {
                        window.print();
                    }}
                    className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md"
                >
                    📥 Descargar PDF
                </button>
            </div>
        </div>
    );
};

export default ResumenEntidad;
